import * as url from "node:url";

const BASE_URL = import.meta.env.MODE === 'test' ? 'https://test.teams.com.tw' : '';

async function fetchAPI(url, options = {}) {
    const opts = { method: 'GET', ...options, credentials: 'include' };

    // 自動加上 cache busting query 參數
    if (opts.method === 'GET') {
        const separator = url.includes('?') ? '&' : '?';
        url += `${separator}_=${Date.now()}`;
    }

    try {
        const response = await fetch(url, opts);
        if (!response.ok) {
            let errorData = {};
            try {
                errorData = await response.json();
            } catch (e) {
                // 回傳不是 JSON，拋出狀態碼錯誤
                const error = new Error(`HTTP error! status: ${response.status}`);
                error.status = response.status;
                throw error;
            }

            // 拋出錯誤並附加錯誤資料與狀態碼
            const error = new Error(errorData.error || `HTTP error! status: ${response.status}`);
            error.status = response.status;
            error.data = errorData;
            throw error;
        }

        return response;
    } catch (error) {
        throw error;
    }
}

export async function fetchPageInfo(pageName, queryParams = {}) {
    const params = new URLSearchParams(queryParams);
    return fetchAPI(`${BASE_URL}/v2api/${pageName}.json?${params}`);
}

export async function fetchLogin(account, password, goto = null) {
    return fetchAPI(`${BASE_URL}/v2api/member/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            account,
            password,
            ...(goto && { goto })
        })
    });
}

export async function fetchLogout() {
    return fetchAPI(`${BASE_URL}/v2api/member/logout`);
}

export async function fetchForgotPassword(email) {
    return fetchAPI(`${BASE_URL}/v2api/member/forgotPassword`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
    });
}

export async function fetchCheckTeamsByHost(host) {
    const params = new URLSearchParams({ host });
    return fetchAPI(`${BASE_URL}/v2api/administrative/checkTeamsByHost?${params}`);
}

export async function fetchLoginTanetPair(host, account, password) {
    return fetchAPI(`${BASE_URL}/v2api/member/loginTanetPair`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ host, account, password })
    });
}

export async function fetchForceChange(name, password) {
    const params = {}
    if (name) params.name = name;
    if (password) params.password = password;
    return fetchAPI(`${BASE_URL}/v2api/member/forceChange`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    });
}

export async function fetchAssessmentUnits(subject, year, version, volume) {
    const params = new URLSearchParams({subject, year, version, volume});
    return fetchAPI(`${BASE_URL}/v2api/student/exam/selfAssessmentUnits?${params}`);
}

/*
    * 發起自我評量題目生成請求
    * @param {Object} params - 包含書籍資訊、選擇的單元、難易度、題數等
        * {subject, year, volume, version} bookInfo - 書籍資訊
        * {Array} units - 選擇的單元
        * {string} difficult - 難易度 (easy | medium | hard)
        * {number} questionNumber - 要出的題數
        * {boolean} ignoreCorrected - 是否要出已答對的題目
        * {string} course - 課程ID
 */
export const fetchCreateAssessment = async (params) => {
    return fetchAPI(`${BASE_URL}/v2api/student/exam/createSelfAssessment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    });
}

export async function fetchUpdateRoomAnswer(data) {
    return fetchAPI(`${BASE_URL}/v2api/student/exam/roomAnswer`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
}

export async function fetchFinishRoom(data) {
    return fetchAPI(`${BASE_URL}/v2api/student/exam/roomFinish`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
}

export async function fetchExamReview(data) {
    return fetchAPI(`${BASE_URL}/v2api/student/exam/review`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
}

export async function fetchExamDelete(id) {
    return fetchAPI(`${BASE_URL}/v2api/student/exam/delete?id=${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export async function fetchWebRoomFinish(id) {
    return fetchAPI(`${BASE_URL}/v2api/student/web/roomFinish`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
    });
}

export async function fetchCinemaRoomVideoProgress(id, index, length) {
    return fetchAPI(`${BASE_URL}/v2api/student/cinema/progress`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, index, length})
    })
}

export async function fetchCinemaRoomPlayed(id) {
    return fetchAPI(`${BASE_URL}/v2api/student/cinema/played`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
    });
}
